import NP from 'number-precision'
export function removeItem(items, item) {
	let index = null
	if (item.id == null) index = [...items].findIndex(_item => _item.key == item.key)
	else index = [...items].findIndex(_item => _item.id == item.id)

	if (index != -1) {
		items.splice(index, 1)
	}
	return items
}

export function removeItemM(items, item) {
	let index = [...items].findIndex(_item => _item.material == item.material)
	if (index != -1) {
		items.splice(index, 1)
	}
	return items
}

export function replaceItem(items, item) {
	let index = [...items].findIndex(_item => _item.id == item.id)
	if (index != -1) {
		items.splice(index, 1, item)
	}
	return items
}

export function insertItem(items, item) {
	let index = items.findIndex(_item => _item.id == item.id)
	if (index == -1) {
		items.push(item)
	}
	return items
}

export function insertItemM(items, item) {
	let index = [...items].findIndex(_item => _item.material == item.material)
	if (index == -1) {
		items.splice(0, 0, item)
	}
	return items
}

export function removeItemBatch(items, item) {
	let index = [...items].findIndex(_item => _item.key == item.key)
	if (index != -1) {
		items.splice(index, 1)
	}
	return items
}
export function getGoodsUnitItems(item) {
	let unitItems = [
		{
			id: item.unit,
			name: item.unit_name,
			ratio: 1
		}
	]

	if (item.enable_units_control) {
		for (let ob of item.goods_unit_items) {
			insertItem(unitItems, {
				id: ob.otherUnit,
				name: ob.other_unit_name,
				ratio: ob.ratio
			})
		}
	}
	return unitItems
}
export function getGoodsItemInfo(item) {
	let _names = []
	let _version = []
	let _color = []
	if (item.purchase_goods_items) {
		_names = item.purchase_goods_items.map(v => {
			if (v.color_name) return v.goods_name + '-' + v.color_name
			else return v.goods_name
		})
		_version = item.purchase_goods_items.filter(v => v.goods_version).map(v => v.goods_version)
		_color = item.purchase_goods_items.filter(v => v.color_name).map(v => v.color_name)
	}
	item.goods_name = _names.join('，')
	item.goods_version = _version.join('，')
	item.goods_color = _color.join(',')
}
/**
 * @description 校验数组对象某属性的值有无重复
 * @param {Array} dataArr 数组
 * @param {String}  key 属性名
 * @param {String}  keyCN 属性中文名
 * @return {String}
 * @example checkArrayObjectValueRepeat(data, 'name', '姓名') => "姓名不能重复" || ""
 */
export function checkArrayObjectValueRepeat(dataArr, key, keyCN) {
	let valArr = []
	let check = ''
	dataArr.some(item => {
		if (valArr.includes(item[key])) return (check = `${keyCN || key}不能重复`)
		valArr.push(item[key])
		return false
	})
	return check
}

export function columnWidth(width, max_width) {
	return column => {
		if (max_width) return { style: { 'min-width': `${width}px`, 'max-width': `${max_width}px` } }
		else return { style: { 'min-width': `${width}px` } }
	}
}

export function round2(n) {
	return NP.divide(Math.floor(NP.times(n, 100)), 100)
}

export default {
	removeItem,
	removeItemM,
	replaceItem,
	insertItem,
	insertItemM,
	removeItemBatch,
	checkArrayObjectValueRepeat,
	columnWidth,
	getGoodsUnitItems,
	round2
}
